// extracted by mini-css-extract-plugin
export default {"buttonDirectionWrapper":"FtvxVr","buttonDirectionWrapper__smallScreen":"g9s6IJ","buttonDirectionWrapperSmallScreen":"g9s6IJ"};